import React from 'react';
import Link from './StyledTextComponents/Link';
import Styled from './StyledTextComponents/Styled';


const StyledText = ({children, ...rest}) => {
  let text = children;
  text = text.split('[-]').join('\u00ad'); //soft hyphen
  const re = /([^\[]+|\[.+?\])/g; //matches strings enclosed in [brackets] and outside
  const matches = text.match(re);

  function isLink(str) {
    var link = /:|\//;
    return str.length < 2083 && link.test(str);
  }

  const enhancedText = (matches && matches.map((str, i) => {
    if (str === '[/]') { // linebreak
      return <br/>;
    }
    else if (str.startsWith("[")) {
      const args = str.substring(1, str.length - 1).split("|").map(arg => arg.trim());
      if (args[1] && isLink(args[1])) {
        return <Link args={args} key={i}/>;
      } else {
        return <Styled args={args} key={i}/>;
      }
    }
    return str;
  })) || text;

  return <span {...rest}>{enhancedText}</span>;
};


export default StyledText;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/StyledText/StyledText.js
 **/